import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';

const CATS = ['all','ladders_access','cleaning','moving','hand_tools','power_tools','safety','other'];
const statusColor = (item) => {
  if (item.quantity_available <= 0) return '#FCEBEB';
  if (item.quantity_available <= item.low_stock_threshold) return '#FAEEDA';
  return '#EAF3DE';
};
const statusLabel = (item) => {
  if (item.quantity_available <= 0) return 'Out of stock';
  if (item.quantity_available <= item.low_stock_threshold) return 'Low stock';
  return 'Available';
};

export default function InventoryPage() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [cat, setCat] = useState('all');
  const [loading, setLoading] = useState(true);

  const load = () => {
    const params = {};
    if (search) params.search = search;
    if (cat !== 'all') params.category = cat;
    axios.get('/api/inventory', { params }).then(r => { setItems(r.data); setLoading(false); }).catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, [cat]);

  return (
    <Layout>
      <div style={{marginBottom:'20px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontSize:'20px',fontWeight:'700',color:'#0C447C',margin:0}}>Inventory</h1>
          <p style={{color:'#888',fontSize:'13px',marginTop:'4px'}}>{items.length} items</p>
        </div>
      </div>
      <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'16px',marginBottom:'16px',display:'flex',gap:'10px',flexWrap:'wrap'}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&load()}
          placeholder="Search items..." style={{flex:1,minWidth:'200px',padding:'8px 12px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
        <button onClick={load} style={{padding:'8px 16px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',cursor:'pointer'}}>Search</button>
        <div style={{display:'flex',gap:'6px',flexWrap:'wrap'}}>
          {CATS.map(c => (
            <button key={c} onClick={()=>setCat(c)} style={{padding:'6px 12px',border:'1px solid #ddd',borderRadius:'20px',fontSize:'12px',cursor:'pointer',
              background:cat===c?'#0C447C':'#fff',color:cat===c?'#fff':'#555'}}>
              {c.replace(/_/g,' ')}
            </button>
          ))}
        </div>
      </div>
      {loading ? <div style={{textAlign:'center',padding:'40px',color:'#888'}}>Loading...</div> : (
        <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',overflow:'hidden'}}>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px'}}>
            <thead>
              <tr style={{background:'#f8f8f8'}}>
                <th style={{padding:'10px 14px',textAlign:'left',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Item</th>
                <th style={{padding:'10px 14px',textAlign:'left',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>SKU</th>
                <th style={{padding:'10px 14px',textAlign:'left',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Category</th>
                <th style={{padding:'10px 14px',textAlign:'center',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Total</th>
                <th style={{padding:'10px 14px',textAlign:'center',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Available</th>
                <th style={{padding:'10px 14px',textAlign:'center',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Out</th>
                <th style={{padding:'10px 14px',textAlign:'left',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item,i) => (
                <tr key={i} style={{borderTop:'1px solid #f5f5f5'}}>
                  <td style={{padding:'10px 14px',fontWeight:'500',color:'#222'}}>{item.name}</td>
                  <td style={{padding:'10px 14px',color:'#888',fontFamily:'monospace'}}>{item.sku}</td>
                  <td style={{padding:'10px 14px',color:'#555',textTransform:'capitalize'}}>{item.category?.replace(/_/g,' ')}</td>
                  <td style={{padding:'10px 14px',textAlign:'center'}}>{item.quantity_total}</td>
                  <td style={{padding:'10px 14px',textAlign:'center',fontWeight:'600',color:'#0C447C'}}>{item.quantity_available}</td>
                  <td style={{padding:'10px 14px',textAlign:'center',color:'#666'}}>{item.quantity_out}</td>
                  <td style={{padding:'10px 14px'}}>
                    <span style={{background:statusColor(item),padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'500',color:item.quantity_available<=0?'#A32D2D':item.quantity_available<=item.low_stock_threshold?'#854F0B':'#27500A'}}>
                      {statusLabel(item)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && <div style={{textAlign:'center',padding:'40px',color:'#888'}}>No items found</div>}
        </div>
      )}
    </Layout>
  );
}
